import { __exportAll } from "../_virtual/_rolldown/runtime.mjs";

// src/utils/zodUtils.ts
var zodUtils_exports = /* @__PURE__ */ __exportAll({
	endOfUtcCalendarDay: () => endOfUtcCalendarDay,
	parseDateSafe: () => parseDateSafe,
	startOfUtcCalendarDay: () => startOfUtcCalendarDay,
	validateData: () => validateData,
	zodTransformFirestoreTimestampToDate: () => zodTransformFirestoreTimestampToDate
});
/**
* Parse unknown timestamp/date-like values into a valid Date.
* Supports Date, Firestore Timestamp-like objects ({ toDate() } or { seconds }),
* strings, and numbers. Returns null for invalid/unsupported inputs.
*/
const parseDateSafe = (value) => {
	if (value === null || value === void 0 || value === "") return null;
	if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
	if (typeof value === "object" && value !== null && "toDate" in value && typeof value.toDate === "function") {
		const parsed = value.toDate();
		if (parsed instanceof Date && !Number.isNaN(parsed.getTime())) return parsed;
		return null;
	}
	if (typeof value === "object" && value !== null && "seconds" in value && typeof value.seconds === "number") {
		const parsed = /* @__PURE__ */ new Date(value.seconds * 1e3);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	}
	if (typeof value === "object" && value !== null && "_seconds" in value && typeof value._seconds === "number") {
		const parsed = /* @__PURE__ */ new Date(value._seconds * 1e3);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	}
	if (typeof value === "string" || typeof value === "number") {
		const parsed = new Date(value);
		return Number.isNaN(parsed.getTime()) ? null : parsed;
	}
	return null;
};
/** UTC calendar-day start (00:00:00.000). Used for inclusive activeFrom boundaries. */
function startOfUtcCalendarDay(date) {
	return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
}
/** UTC calendar-day end (23:59:59.999). Used for inclusive activeThrough boundaries. */
function endOfUtcCalendarDay(date) {
	return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), 23, 59, 59, 999));
}
/** Coerces Firestore Timestamp / plain objects / ISO strings into a `Date` for Zod `.transform()`.
* Uses {@link parseDateSafe} for parsing; returns the original value when parsing fails so
* downstream `.pipe(z.date())` or optional fields can reject or preserve raw input.
* BigQuery schema codegen recognizes this exact function and emits `timestamp` (see `zodToBqFields.ts`).
*/
const zodTransformFirestoreTimestampToDate = (timestamp) => {
	return parseDateSafe(timestamp) ?? timestamp;
};
/**
* Generic validation utility function for Zod schemas
* @param schema Zod schema to validate against
* @param data Data to validate
* @param operationName Name of the operation for error messages
* @returns Validated data of type T
* @throws Error with detailed validation messages
*/
function validateData(schema, data, operationName = "operation") {
	const validationResult = schema.safeParse(data);
	if (!validationResult.success) {
		const errorMessages = validationResult.error.issues.map((issue) => `${issue.path.join(".")}: ${issue.message}`).join(", ");
		throw new Error(`Invalid data for ${operationName}: ${errorMessages}`);
	}
	return validationResult.data;
}

export { endOfUtcCalendarDay, parseDateSafe, startOfUtcCalendarDay, validateData, zodTransformFirestoreTimestampToDate, zodUtils_exports };
//# sourceMappingURL=zodUtils.mjs.map